// start:ng42.barrel
export * from './mazaya-plus.service';
// end:ng42.barrel

